import React, { Component } from 'react'
import img1 from '../img/shoe1.jpeg'
import img2 from '../img/shoe2.jpeg'
import img3 from '../img/shoe3.jpeg'
import img4 from '../img/shoe4.jpeg'
import img5 from '../img/shoe5.jpeg'

const name = "DANIELS MACDONALD'S FOOTWARE"


export default [
 {
  "_id": "1",
  "title": name,
  "src": img1,
  "description": "Palm Classy Yellow Slippers",
  "content": "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  "size": "35-40",
  "price": 4000,
  "colors": ["red", "black", "crimson", "teal"],
  "count": 1
 },
 {
  "_id": "2",
  "title": name,
  "src": img2,
  "description": "Palm Classy Black Slippers",
  "content": "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  "size": "35-40",
  "price": 4000,
  "colors": ["red", "crimson", "teal"],
  "count": 1
 },
 {
  "_id": "3",
  "title": name,
  "src": img3,
  "description": "Palm Classy Different coloured Slippers",
  "content": "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  "size": "35-40",
  "price": 5000,
  "colors": ["lightblue", "white", "crimson", "teal"],
  "count": 1
 },
 {
  "_id": "4",
  "title": name,
  "src": img4,
  "description": "Women Classy White Palm",
  "content": "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  "size": "35-40",
  "price": 5000,
  "colors": ["orange", "black", "crimson", "teal"],
  "count": 1
 },
 {
  "_id": "5",
  "title": name,
  "src": img5,
  "description": "Women Classy Orange Slippers",
  "content": "Welcome to our channel Dev AT. Here you can learn web designing, UI/UX designing, html css tutorials, css animations and css effects, javascript and jquery tutorials and related so on.",
  "size": "35-40",
  "price": 4000,
  "colors": ["orange", "black", "crimson", "teal"],
  "count": 1
 }
]